.disclosureContainer{
    background-color: #f1f1f1 !important ;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 30px;
    color: #464646 !important;
    font-size: 13px;
    display: "flex",
}
